import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { ForgotPasswordProps } from "./types";

export class ForgotPasswordDefinitions extends CmsReactComponent<ForgotPasswordProps> {
    static defaultProps = {};

    static schemaName = "forgot-password";

    static propertyDefinitions: PropertyDefinition[] = [{
        name: "forgotPasswordTitle",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Şifremi Unuttum Başlık",
    },
    {
        name: "forgotPasswordDescription",
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        text: "Şifremi Unuttum Açıklama",
    },
    {
        name: "approveCodeTitle",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Onay Kodu Başlık",
    },
    {
        name: "approveCodeDescription",
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        text: "Onay Kodu Açıklama",
    },
    {
        name: "newPasswordTitle",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Yeni Şifre Başlık",
    },
    {
        name: "newPasswordDescription",
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        text: "Yeni Şifre Açıklama",
    },];
}
